import { Icon, IconSource, Pressable, Text, tva } from 'aos-ui-universal'
import React from 'react'

import { taskChip } from './taskChip'

const optionChipLayout = tva({
    base: 'items-center justify-center gap-2 px-2 py-3',
    variants: {
        orientation: {
            horizontal: 'flex-row',
            vertical: 'min-h-[80px] flex-col',
        },
    },
    defaultVariants: { orientation: 'horizontal' },
})

interface TaskOptionChipProps {
    label: string
    icon?: IconSource
    isSelected: boolean
    disabled?: boolean
    orientation?: 'horizontal' | 'vertical'
    onPress(): void
}

export const TaskOptionChip = ({
    label,
    icon,
    isSelected,
    disabled,
    orientation = 'horizontal',
    onPress,
}: TaskOptionChipProps) => (
    <Pressable
        accessibilityRole='radio'
        accessibilityState={{ selected: isSelected, disabled: !!disabled }}
        disabled={disabled}
        onPress={onPress}
        className={taskChip({
            isSelected,
            isDisabled: !!disabled,
            class: optionChipLayout({ orientation }),
        })}
    >
        {icon ? (
            <Icon
                as={icon}
                size={24}
                className={isSelected ? 'text-aos-text-on-primary' : 'text-aos-text-default'}
            />
        ) : null}
        <Text
            size='body'
            tone={isSelected ? 'on-primary' : 'default'}
            numberOfLines={2}
            className='text-center'
        >
            {label}
        </Text>
    </Pressable>
)
